/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Validation_Non_OptionalInputs */

const en_validation_non_optional = /** @type {(inputs: Validation_Non_OptionalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Field "${i?.key}" is required!`)
};

const de_validation_non_optional = /** @type {(inputs: Validation_Non_OptionalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wert "${i?.key}" ist erforderlich!`)
};

/**
* | output |
* | --- |
* | "Field \"{key}\" is required!" |
*
* @param {Validation_Non_OptionalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_non_optional = /** @type {((inputs: Validation_Non_OptionalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Non_OptionalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_non_optional(inputs)
	return en_validation_non_optional(inputs)
});